import {errorCodes, defaultProcessingError} from "../constants/index";

export function isUserAuthenticated() {
  let isUserAuthenticated = false;
  if (sessionStorage.getItem('isUserAuthenticated')) {
      isUserAuthenticated = (sessionStorage.getItem('isUserAuthenticated') === 'true');
  }
  return isUserAuthenticated;
}

export function getPublicURL(path) {
  return window.location.protocol + '//' + window.location.host + '/' + path;
}

export function returnErrorMessage(error, defaultErrorCode){
  let msg = ''
  if (error.response.data.detail.hasOwnProperty('ErrorCode')) {
    msg = errorCodes[error.response.data.detail["ErrorCode"]]
  } else {
    msg = errorCodes[defaultErrorCode]
  }
  if (msg === undefined){
    msg = defaultProcessingError;
  }
  return msg;
}

export function appendIfNotEmptyOrNull(key, value, formData){
  if((value !== '') && (value !== undefined)){
    formData.append(key, value);
  }
  return formData;
}


// WEBPACK FOOTER //
// ./src/shared/utils.js